/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Loader, Image } from '@components/common';
import { PLAID_KEY, APP_ENV } from '@config';
import Actions, { thunks } from '@redux/app';
import utils from '@utils';
import CreditCardForm from './CreditCardForm/CreditCardForm';
import BankAccountForm from './BankAccountForm';
import PlaidWidget from './PlaidWidget';

import './PaymentMethodForm.scss';

class PaymentMethodForm extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showBankAccountForm : false,
			type                : props.achPrePayEnabled ? 'bankAccount' : 'creditCard',
			bankAccountForm     : {
				routingNo : {
					value      : '',
					validation : null,
					rules      : 'required|numeric',
				},
				accountNo : {
					value      : '',
					validation : null,
					rules      : 'required|numeric|confirmed',
				},
				accountNo_confirmation : {
					value      : '',
					validation : null,
					rules      : 'required|numeric',
				},
				accountType : {
					value      : '',
					validation : null,
					rules      : 'required',
				},
				bankHolderName : {
					value      : '',
					validation : null,
					rules      : 'required',
				},
			},
		};
	}

	// Only manual bank accounts run this submit handler
	onSubmitBankAccount = () => {
		const { bankAccountForm } = this.state;
		const {
			addPaymentMethod, setLoading, onSubmit, isPrePayForm, successCallback,
		} = this.props;

		// Validate form
		const { isValid, form: validatedForm, values } = utils.validateForm(bankAccountForm);
		this.setState({ bankAccountForm : validatedForm });

		if (!isValid) return;

		setLoading('addPaymentMethod', true);
		if (onSubmit) {
			onSubmit({ type : 'bankAccount', values });
		} else {
			addPaymentMethod({ ...values, type : 'bankAccount' }, isPrePayForm && successCallback ? this.successCallback : onSubmit);
		}
	}

	onPlaidSuccess = (token, metadata) => {
		const {
			addBankAccountWithPlaid, setLoading, onSubmit, onPlaidSuccess,
		} = this.props;

		setLoading('addPaymentMethod', true);

		if (onPlaidSuccess) {
			onPlaidSuccess(token, metadata);
		} else {
			addBankAccountWithPlaid(token, metadata.account_id, onSubmit);
		}
	}

	handleBankAccountFormChange = (property) => (event) => {
		let value = '';
		if (event && event.value) value = event.value;
		if (event && event.target && event.target.value) value = event.target.value;

		this.setState((state) => ({
			bankAccountForm : { ...state.bankAccountForm, [property] : { ...state[property], value } },
		}));
	}

	toggleBankForm = () => {
		this.setState((state) => ({ showBankAccountForm : !state.showBankAccountForm, cancelClicked : false }));
	}

	onRadioChange = (event) => {
		this.setState({ type : event.target.value });
	}

	successCallback = () => {
		const { resetForm, successCallback } = this.props;
		resetForm('addPayment');

		if (successCallback) successCallback();
	}

	onCancelPrePay = () => this.setState({ showBankAccountForm : false, type : 'bankAccount' });

	render() {
		const {
			user, loadingAddPaymentMethod, onCancel, userAddress, cancelLabel, submitLabel, onSubmit, isPrePayForm, achPrePayEnabled,
		} = this.props;

		const address = userAddress || {
			address_line1 : user.StreetAddress,
			address_city  : user.City,
			_state        : user.StateId,
			address_state : `${user.StateAbbreviation} - ${user.StateName}`,
			address_zip   : user.Zip,
		};

		const plaidSettings = {
			env       : APP_ENV === 'production' ? APP_ENV : 'sandbox',
			publicKey : PLAID_KEY,
			onSuccess : this.onPlaidSuccess,
			onExit    : this.onExit,
		};

		const {
			bankAccountForm, type, showBankAccountForm,
		} = this.state;

		return (
			<div id="add-payment-form" className={isPrePayForm ? 'container-fluid' : ''}>
				<div className={isPrePayForm ? 'prepay-form col-xs-10 col-xs-offset-1 col-md-6 col-md-offset-3' : ''}>
					<div className="margin-left-15 margin-right-15">
						<If condition={achPrePayEnabled}>
							<div className="margin-bottom-15 padding-top-10">
								<span className="font-bold color-gray-mine-shaft font-size-16">
									Payment Method
								</span>
								<Image
									className="margin-left-20"
									src="/images/cardImage.png"
								/>
							</div>
						</If>
						<div className="form-group">
							<div className="flex flex-align-items-center">
								<div className="radio">
									<label htmlFor="paymentType_bankAccount">
										<input
											type="radio"
											name="paymentType"
											value="bankAccount"
											id="paymentType_bankAccount"
											onChange={this.onRadioChange}
											checked={type === 'bankAccount'}
										/>
										ACH Bank Transfer
									</label>
								</div>
								<div className="radio margin-left-30 margin-top-10">
									<label htmlFor="paymentType_creditCard">
										<input
											type="radio"
											name="paymentType"
											value="creditCard"
											id="paymentType_creditCard"
											onChange={this.onRadioChange}
											checked={type === 'creditCard'}
										/>
										Credit Card
									</label>
								</div>
							</div>
						</div>
						<Choose>
							<When condition={type === 'bankAccount'}>
								<Choose>
									<When condition={showBankAccountForm}>
										<BankAccountForm
											form={bankAccountForm}
											onChange={this.handleBankAccountFormChange}
											onSubmit={this.onSubmitBankAccount}
										/>
									</When>
									<Otherwise>
										<PlaidWidget
											env={plaidSettings.env}
											public_key={plaidSettings.publicKey}
											onSuccess={plaidSettings.onSuccess}
											onExit={plaidSettings.onExit}
										/>
										<br />
										<div className="media" id="manual-ach-link">
											<button type="button" onClick={this.toggleBankForm}>
												<div className="media-left media-middle">
													<div className="media-object">
														<i className="glyphicon glyphicon-edit" />
													</div>
												</div>
												<div className="media-right media-body media-middle">
													<div className="h4 media-heading"><strong>Manually Add Account</strong></div>
													<span className="text-muted">Add account using a routing and account number</span>
												</div>
											</button>
										</div>
									</Otherwise>
								</Choose>
							</When>
							<When condition={type === 'creditCard'}>
								<CreditCardForm
									userAddress={address}
									onSubmit={onSubmit}
									successCallback={this.successCallback}
									cancelCallback={isPrePayForm ? this.onCancelPrePay : onCancel}
									cancelLabel={cancelLabel}
									submitLabel={submitLabel}
									isPrePayForm
								/>
							</When>
						</Choose>
					</div>
					<div className="text-right margin-top-30">
						<div className="form-group">
							<If condition={type === 'bankAccount' && showBankAccountForm}>
								<button
									type="button"
									className="btn btn-link margin-right-10"
									onClick={isPrePayForm ? this.onCancelPrePay : onCancel}
								>
									{cancelLabel}
								</button>
								<button
									type="button"
									className="btn btn-primary"
									onClick={this.onSubmitBankAccount}
								>
									{submitLabel}
								</button>
							</If>
						</div>
					</div>
					<Loader active={loadingAddPaymentMethod} />
				</div>
			</div>
		);
	}
}

const mapStateToProps = ({
	app : {
		loaders : {
			addPaymentMethod : loadingAddPaymentMethod,
		},
	},
}) => ({
	loadingAddPaymentMethod,
});

const mapDispatchToProps = (dispatch) => ({
	resetForm               : bindActionCreators(Actions, dispatch).resetForm,
	setLoading              : bindActionCreators(Actions, dispatch).setLoading,
	addPaymentMethod        : bindActionCreators(thunks, dispatch).addPaymentMethod,
	addBankAccountWithPlaid : bindActionCreators(thunks, dispatch).addBankAccountWithPlaid,
});

PaymentMethodForm.propTypes = {
	addBankAccountWithPlaid : PropTypes.func.isRequired,
	addPaymentMethod        : PropTypes.func.isRequired,
	loadingAddPaymentMethod : PropTypes.bool,
	setLoading              : PropTypes.func.isRequired,
	resetForm               : PropTypes.func.isRequired,
	user                    : PropTypes.object,
	onSubmit                : PropTypes.func,
	onCancel                : PropTypes.func,
	onPlaidSuccess          : PropTypes.func,
	successCallback         : PropTypes.func,
	userAddress             : PropTypes.object,
	cancelLabel             : PropTypes.string,
	submitLabel             : PropTypes.string,
	isPrePayForm            : PropTypes.bool,
	achPrePayEnabled        : PropTypes.bool,
};

PaymentMethodForm.defaultProps = {
	loadingAddPaymentMethod : false,
	user                    : {},
	onSubmit                : undefined,
	onCancel                : undefined,
	onPlaidSuccess          : undefined,
	successCallback         : undefined,
	userAddress             : undefined,
	cancelLabel             : 'Cancel',
	submitLabel             : 'Save',
	isPrePayForm            : false,
	achPrePayEnabled        : true,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentMethodForm);
